(() => {
  const input = document.querySelector('[data-gk-coll-filter]');
  const list = document.querySelector('[data-gk-coll-list]');
  if (!input || !list) return;

  const items = [...list.querySelectorAll('[data-gk-coll-title]')];
  const empty = document.querySelector('[data-gk-coll-empty]');

  input.addEventListener('input', () => {
    const query = input.value.trim().toLowerCase();
    let visible = 0;
    items.forEach((item) => {
      const match = !query || item.dataset.gkCollTitle.includes(query);
      item.hidden = !match;
      if (match) visible += 1;
    });
    if (empty) empty.hidden = visible > 0;
  });
})();
